module.exports = __webpack_public_path__ + "img/nav-qbgl.26a6d191.png";